import React from "react";
import { Link } from "react-router-dom";
import "../styles/Footer.css";
import logo from "../assets/UHCS-logo-N01.webp"

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-wrap">

        {/* =========================================================
            1. IDENTITY
        ========================================================== */}

        <div className="footer-identity">
          <img
            src={logo}
            width="192"
            height="150"
            loading="lazy"
            decoding="async"
            alt="Finex Industries — Beyond Boundaries"
          />
          <p className="footer-description">
            Dedicated to improving quality healthcare services and standards across India under JCI & NABH guidelines for affordable health for all.
          </p>



        </div>


        {/* =========================================================
            2. QUICK LINKS
        ========================================================== */}

        <nav
          className="footer-column footer-links-column"
          aria-labelledby="footer-links-heading"
        >
          <h2
            className="footer-heading"
            id="footer-links-heading"
          >
            Quick Links
          </h2>

          <ul className="footer-list">

            <li>
              <Link to="/">
                Home
              </Link>
            </li>

            <li>
              <Link to="/about">
                About
              </Link>
            </li>

            <li>
              <Link to="/projects">
                Working Sectors (1-8)
              </Link>
            </li>

            <li>
              <Link to="/certifications">
                Impact Gallery

              </Link>
            </li>

            <li>
              <Link to="/careers">
                Action Plan 2035
              </Link>
            </li>

            <li>
              <Link to="/contact">
                Contact
              </Link>
            </li>

          </ul>
        </nav>




        {/* =========================================================
            4. CONTACT
        ========================================================== */}

        <div className="footer-contact">

          <h2 className="footer-heading">
            Contact
          </h2>

          <ul className="contact-list">

            {/* =====================================================
                ADDRESS
            ====================================================== */}

            <li className="contact-row">

              <span className="contact-icon">

                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 1 1 16 0Z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>

              </span>

              <span className="contact-body">

                <span className="contact-text">

                  <span className="sr-only">
                    Address:
                  </span>

                  UHCS-BMC Building , Opp. Dream Mall, Near Bhandup Rly. Station,Bhandup Mumbai- India. Pin Code- 40078 

                  <br />

                  {/* <a
                    className="contact-inline-link"
                    href="https://www.google.com/maps/search/?api=1&query=4R77%2BXW%2C%20Dhakambe%2C%20Pimpalnare%2C%20Maharashtra%20422004"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    View on Google Maps
                  </a> */}

                </span>

              </span>

            </li>


            {/* =====================================================
                PHONE
            ====================================================== */}

            <li className="contact-row">

              <span className="contact-icon">

                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.4 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.5c.9.09 1.8.6 2.8.7a2 2 0 0 1 1.7 2z" />
                </svg>

              </span>

              <span className="contact-body">

                <a
                  className="contact-main-link"
                  href="tel:+917020391946"
                >
                  7020391946 / 8484908244 /  7710950010 / 9819518559 
                </a>

              </span>

            </li>



            

          </ul>



        </div>

      </div>





    </footer>
  );
}

export default Footer;